module.exports = __webpack_public_path__ + "assets/images/project/head/Juju_Noda.jpg?v=5da212c8";